import { setWorkspaceLanguage, switchLanguagePath, t, useWorkspaceLanguage, type WorkspaceLanguage } from "../lib/i18n";

const LANGUAGE_OPTIONS: Array<{ value: WorkspaceLanguage; label: string }> = [
  { value: "de", label: "DE" },
  { value: "en", label: "EN" }
];

export function LanguageSwitcher() {
  const language = useWorkspaceLanguage();
  const labels = t(language);

  function handleSwitch(nextLanguage: WorkspaceLanguage) {
    setWorkspaceLanguage(nextLanguage);
    if (typeof window !== "undefined") {
      window.location.assign(switchLanguagePath(`${window.location.pathname}${window.location.search}${window.location.hash}`, nextLanguage));
    }
  }

  return (
    <div className="language-switcher" aria-label={labels.layout.languageLabel}>
      {LANGUAGE_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={option.value === language ? "language-option language-option-active" : "language-option"}
          aria-pressed={option.value === language}
          onClick={() => handleSwitch(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
